import React from 'react';
import SubjectPage from '../../subjects/SubjectPage';


function ToperNotes() {


  const pageTitleText = "NEET Topper Notes";


  return (
    <>
     

      <SubjectPage 
        name={pageTitleText} 
        link="topernote" 
        type="topernote"
      />

     
    </>
  );
}

export default ToperNotes;